import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShoppingCart from '../shopping-cart/shopping-cart.reducer';

export interface State {
  tempShoppingCartFeature: fromShoppingCart.TempShoppingCartState;
  shoppingCartFeature: fromShoppingCart.ShoppingCartState;
}
export const tempShoppingCartReducers: ActionReducerMap<State> = {
  tempShoppingCartFeature: fromShoppingCart.tempShoppingCartReducer,
  shoppingCartFeature: fromShoppingCart.shoppingCartReducer,
};

const getTempShoppingCartFeatureState =
  createFeatureSelector<fromShoppingCart.TempShoppingCartState>('tempShoppingCartFeature');

export const getTempShoppingCartByIdMember = createSelector(getTempShoppingCartFeatureState, state => {
  return state.tempShoppingCartDetails;
});

export const idMember = createSelector(getTempShoppingCartFeatureState, state => {
  return state.idMember;
});

const getShoppingCartFeatureState = createFeatureSelector<fromShoppingCart.ShoppingCartState>('shoppingCartFeature');

export const getShoppingCartSummary = createSelector(getShoppingCartFeatureState, state => {
  return state.shoppingCartSummary;
});
